import { useParams } from "react-router-dom";
import Page from "../../components/Page";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { url } from "../../url";
import { useEffect, useState } from "react";
import styles from "./singleteammate.module.scss";
import FavoriteBorderIcon from "@mui/icons-material/FavoriteBorder";
import FavoriteIcon from "@mui/icons-material/Favorite";
import ChatIcon from "@mui/icons-material/Chat";
import { useAtom } from "jotai";
import { userTeammatesAtom } from "../Teammate/atoms/UserTeammatesAtomGlobal";
import { chosenUserAtom } from "../Conversations/atoms/ChatAtom";
import Alert from "@mui/material/Alert";
import { Check } from "@mui/icons-material";
import { socket } from "../../socket/socket";
import React from "react";
import { FILTERS } from '../../filters/filtersConfig';

const getData = async (id: string) => {
  const response = await axios.get(url + `/teammate/${id}`, {
    headers: { "Content-Type": "application/json" },
  });
  return response.data;
};

const getSavedData = async (token: string) => {
  const response = await axios.get(url + "/user/teammates/found", {
    headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
  });
  return response.data;
};

const getUserData = async (token: string) => {
    const response = await axios.get(url + "/user/myTeammate", {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  };

interface TeammateDetailProps {
  dataFromMySkills?: any;
}

interface TeammateDetailContentProps {
  dataFromMySkills?: any;
  isEmbedded?: boolean;
}

const TeammateDetailContent = ({ dataFromMySkills, isEmbedded = false }: TeammateDetailContentProps) => {
  const [data, setData] = useState<any>(dataFromMySkills || null);
  const [teammateCreator, setTeammateCreator] = useState<any>({});
  const [userTeammates, setUserTeammates] = useAtom(userTeammatesAtom);
  const [userCreatedTeammateId, setUserCreatedTeammateId] = useState<string | null>(null);
  const [loading, setLoading] = useState<boolean>(true);
  const [message, setMessage] = useState<string>("");
  const { id } = useParams();
  const navigate = useNavigate();
  const [chosenUser, setChosenUser] = useAtom(chosenUserAtom);
  const [showAlert, setShowAlert] = useState<boolean>(false);

  const addTeammate = async (teammate: any): Promise<void> => {
    const token = localStorage.getItem("token");
    if (token) {
      try {
        await axios.post(
          url + `/user/teammates/${teammate._id}`,
          {},
          { headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` } }
        );
        setUserTeammates([...userTeammates, teammate._id]);
      } catch (err) {
        console.log(err);
      }
    }
  };

  const deleteUserTeammates = async (teammate: any): Promise<void> => {
    const token = localStorage.getItem("token");
    if (token) {
      try {
        await axios.delete(url + `/user/teammates/${teammate._id}`, {
          headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
        });
        setUserTeammates(userTeammates.filter((p: any) => p !== teammate._id));
      } catch (err) {
        console.log(err);
      }
    }
  };

  const redirectToConversation = (teammateCreator: any) => {
    if (localStorage.getItem("token")) {
      setChosenUser(teammateCreator);
      navigate("/conversations");
    } else {
      navigate("/login");
    }
  };

  const handleHeartClick = () => {
    const token = localStorage.getItem("token");
    if (!token) {
      navigate("/login");
      return;
    }
    
    !userTeammates?.includes(data._id)
      ? addTeammate(data)
      : deleteUserTeammates(data);
  };

  const onClickSendMessageButtonClick = async () => {
    const token = localStorage.getItem("token");
    if (token) {
      try {
        const response = await axios.post(
          url + `/chat/singlePage/sendMessage`,
          {
            id: teammateCreator._id,
            message: message,
          },
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        const data = response.data;
        socket.emit("join", data.message.conversationId);
        socket.emit("chat", {
          room: data.message.conversationId,
          user: teammateCreator._id,
          text: message,
        });
        socket.off("join");
        socket.off("chat");
        setShowAlert(true);
        setTimeout(() => setShowAlert(false), 3500);
        setMessage("");
        return;
      } catch (err) {
        if (err) {
          return alert("???");
        }
      }
    }
    return alert("You need to be logged lol");
  };

  useEffect(() => {
    if (dataFromMySkills) {
      setData(dataFromMySkills);
      setLoading(false);
      return;
    }
    setLoading(true);
    const fetchData = async () => {
      if (id) {
        const response = await getData(id);
        setData(response.teammate);
        setTeammateCreator(response.teammate_creator);
        setLoading(false);
      }
    };
    fetchData();
  }, [id, dataFromMySkills]);

  useEffect(() => {
    const fetchData = async () => {
      const token = localStorage.getItem("token");
      if (token) {
        const response = await getUserData(token);
        setUserCreatedTeammateId(response.userTeammateProfile);
      }
    };
    fetchData();
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      const token = localStorage.getItem("token");
      if (token) {
        const response = await getSavedData(token);
        setUserTeammates(response.teammates);
      }
    };
    fetchData();
  }, []);

  if (loading) {
    return isEmbedded ? <div>Loading...</div> : <Page><div>Loading...</div></Page>;
  }

  if (!data) {
    return isEmbedded ? <div>Teammate not found.</div> : <Page><div>Teammate not found.</div></Page>;
  }

  const content = (
    <div className={styles.pageWrapper}>
      <main className={styles.mainContent}>
        {/* Header */}
        <header className={styles.header}>
          <div className={styles.titleWrapper}>
            <h1 className={styles.projectName}>{data.nickname}</h1>
          </div>
          {(((typeof userCreatedTeammateId === 'object' && (userCreatedTeammateId as any)?._id !== data._id)) || (typeof userCreatedTeammateId === 'string' && userCreatedTeammateId !== data._id)) && (
            <div className={styles.actions}>
              <button className={styles.iconButton} onClick={handleHeartClick}>
                {userTeammates?.includes(data._id) ? <FavoriteIcon /> : <FavoriteBorderIcon />}
              </button>
              <button className={styles.iconButton} onClick={() => redirectToConversation(teammateCreator)}>
                <ChatIcon />
              </button>
            </div>
          )}
          {/* Edit button tylko dla właściciela profilu */}
          {((typeof userCreatedTeammateId === 'object' && (userCreatedTeammateId as any)?._id === data._id) || (typeof userCreatedTeammateId === 'string' && userCreatedTeammateId === data._id)) && (
            <button
              className={styles.editButton}
              onClick={() => navigate(`/teammates/editTeammate/${data._id}`)}
            >
              Edit Profile
            </button>
          )}
        </header>

        {/* Description */}
        <section className={styles.descriptionSection}>
          <p>{data.description}</p>
        </section>

        {/* Details Grid */}
        <section className={styles.detailsGrid}>
          {typeof data.availability === "number" && (
            <div className={styles.detailItem}>
              <strong className={styles.detailLabel}>{FILTERS.requiredAvailability.label}:</strong>
              <span className={styles.detailValue}>
                {`${data.availability} hours per week`}
              </span>
            </div>
          )}
          {data.locations && data.locations.length > 0 && (
            <div className={styles.detailItem}>
              <strong className={styles.detailLabel}>{FILTERS.locations.label}:</strong>
              <div className={styles.tagGroup}>
                {data.locations.map((item: string, index: number) => (
                  <span key={index} className={styles.tag}>{item}</span>
                ))}
              </div>
            </div>
          )}
          {(data.workingTypeOffice || data.workingTypeRemote) && (
            <div className={styles.detailItem}>
              <strong className={styles.detailLabel}>{FILTERS.offeredWorkingType.label}:</strong>
              <div className={styles.tagGroup}>
                {data.workingTypeOffice && <span className={styles.tag}>Office</span>}
                {data.workingTypeRemote && <span className={styles.tag}>Remote</span>}
              </div>
            </div>
          )}

          {/* Experience */}
          {data.projectType && data.projectType.length > 0 && (
            <div className={styles.detailItem}>
              <strong className={styles.detailLabel}>{FILTERS.projectType.label}:</strong>
              <div className={styles.tagGroup}>
                {data.projectType.map((item: string, index: number) => (
                  <span key={index} className={styles.tag}>{item}</span>
                ))}
              </div>
            </div>
          )}
          {data.areaOfExpertise && data.areaOfExpertise.length > 0 && (
            <div className={styles.detailItem}>
              <strong className={styles.detailLabel}>{FILTERS.industry.label}:</strong>
              <div className={styles.tagGroup}>
                {data.areaOfExpertise.map((item: string, index: number) => (
                  <span key={index} className={styles.tag}>{item}</span>
                ))}
              </div>
            </div>
          )}
          {data.productType && data.productType.length > 0 && (
            <div className={styles.detailItem}>
              <strong className={styles.detailLabel}>{FILTERS.productType.label}:</strong>
              <div className={styles.tagGroup}>
                {data.productType.map((item: string, index: number) => (
                  <span key={index} className={styles.tag}>{item}</span>
                ))}
              </div>
            </div>
          )}
          {data.reward && data.reward.length > 0 && (
            <div className={styles.detailItem}>
              <strong className={styles.detailLabel}>{FILTERS.reward.label}:</strong>
              <div className={styles.tagGroup}>
                {data.reward.map((item: string, index: number) => (
                  <span key={index} className={styles.tag}>{item}</span>
                ))}
              </div>
            </div>
          )}
          {data.compensationBasis && data.compensationBasis.length > 0 && (
            <div className={styles.detailItem}>
              <strong className={styles.detailLabel}>{FILTERS.compensationBasis.label}:</strong>
              <div className={styles.tagGroup}>
                {data.compensationBasis.map((item: string, index: number) => (
                  <span key={index} className={styles.tag}>{item}</span>
                ))}
              </div>
            </div>
          )}
          {data.tools && data.tools.length > 0 && (
            <div className={styles.detailItem}>
              <strong className={styles.detailLabel}>{FILTERS.tools.label}:</strong>
              <div className={styles.tagGroup}>
                {data.tools.map((item: string, index: number) => (
                  <span key={index} className={styles.tag}>{item}</span>
                ))}
              </div>
            </div>
          )}
          {data.softSkills && data.softSkills.length > 0 && (
            <div className={styles.detailItem}>
              <strong className={styles.detailLabel}>{FILTERS.softSkills.label}:</strong>
              <div className={styles.tagGroup}>
                {data.softSkills.map((item: string, index: number) => (
                  <span key={index} className={styles.tag}>{item}</span>
                ))}
              </div>
            </div>
          )}
          {data.hardSkills && data.hardSkills.length > 0 && (
            <div className={styles.detailItem}>
              <strong className={styles.detailLabel}>{FILTERS.hardSkills.label}:</strong>
              <div className={styles.tagGroup}>
                {data.hardSkills.map((item: string, index: number) => (
                  <span key={index} className={styles.tag}>{item}</span>
                ))}
              </div>
            </div>
          )}
          {data.skillsOrientation && data.skillsOrientation.length > 0 && (
            <div className={styles.detailItem}>
              <strong className={styles.detailLabel}>{FILTERS.skillsOrientation.label}:</strong>
              <div className={styles.tagGroup}>
                {data.skillsOrientation.map((item: string, index: number) => (
                  <span key={index} className={styles.tag}>{item}</span>
                ))}
              </div>
            </div>
          )}
        </section>

        {/* Message Section */}
        {(((typeof userCreatedTeammateId === 'object' && (userCreatedTeammateId as any)?._id !== data._id)) || (typeof userCreatedTeammateId === 'string' && userCreatedTeammateId !== data._id)) && (
          <section className={styles.messageSection}>
            <div className={styles.messageInputWrapper}>
              <input
                type="text"
                placeholder="Write a message..."
                value={message}
                onChange={(e) => setMessage(e.target.value)}
                className={styles.messageInput}
                onKeyPress={(e) => e.key === 'Enter' && onClickSendMessageButtonClick()}
              />
              <button onClick={onClickSendMessageButtonClick} className={styles.sendButton}>
                Send
              </button>
            </div>
            {showAlert && (
              <Alert severity="success" className={styles.alert}>
                Message sent successfully!
              </Alert>
            )}
          </section>
        )}
      </main>
    </div>
  );

  return isEmbedded ? content : <Page>{content}</Page>;
};

const TeammateDetail = ({ dataFromMySkills }: TeammateDetailProps) => {
  return <TeammateDetailContent dataFromMySkills={dataFromMySkills} isEmbedded={false} />;
};

export default TeammateDetail;
export { TeammateDetailContent };
